<a (click)="navigateToLink()" class="list-item">
  <img [src]="logoPath" class="image-header"/>
  <div class="divider"></div>
  <p translate>{{description}}</p>

  <div class="connected-item">
    <img [src]="connectedIcon" />
  </div>

  <div *ngIf="isComingSoon" class="coming-soon-label" translate>
    SOON
  </div>
</a>
